import type { DirectoryUserInfoProps } from './types';
import { MobXProviderContext, observer } from 'mobx-react';
import React from 'react';

import type { RootStoreProps } from 'Stores/RootStore.types';
import { BodyCopy } from '../../../shared/BodyCopy';
import { Heading } from '../../../shared/Heading';
import { UserAvatar } from '../../../shared/UserAvatar';
import { Styled } from './index.styles';

export const DirectoryUserInfo: React.FC<DirectoryUserInfoProps> = observer(
  ({ data }) => {
    const {
      ui: { selectPersonPresenceStatus },
    } = React.useContext<RootStoreProps>(MobXProviderContext);
    const { name } = data;

    const presence = selectPersonPresenceStatus(data.sourceId);

    return (
      <Styled.UserInfo>
        <UserAvatar name={name} presence={presence} image={data.avatarUrl} />
        <Styled.UserInfoContent>
          <Heading variant="h6" noMargin>
            {name}
          </Heading>
          <BodyCopy noMargin>
            {data.role}
            {data.role && data.department && ', '}
            {data.department}
          </BodyCopy>
        </Styled.UserInfoContent>
      </Styled.UserInfo>
    );
  }
);
